<template>
  <div class="upLyric">
    <el-upload
      v-if="desc==''"
      class="upload-demo"
      action="/api/oss/upload"
      :on-success="handleChange"
      accept=".lrc"
      multiple
      :limit="1"
      :on-remove="handleRemove"
      :file-list="fileList"
    >
      <svg-icon icon-class="upLyric"></svg-icon>
      <span style="padding-left: 5px;">(仅支持LRC格式)</span>
    </el-upload>
    <span style="padding-left: 20px;" v-if="fileList.length==0&&desc==''">或</span>
    <div style="width: 340px;position: relative;" class="area" v-if="fileList.length==0">
      <el-input type="textarea" v-model="desc" placeholder="直接将歌词黏贴进来~ 注意排版格式，不然会影响播放页面的歌词美观程度"></el-input>
      <el-button @click="upLrc">确认</el-button>
    </div>
  </div>
</template>

<script>
import { upLrc } from "@/api/personal";
export default {
  name: "index",
  data() {
    return {
      fileList: [],
      desc: "",
    };
  },
  watch: {
    desc() {
      this.$store.commit("ADD_LRC", this.desc);
    },
  },
  methods: {
    upLrc() {
      let d = {
        lyricContent: this.desc,
      };
      upLrc(d).then((res) => {
        this.$message({
          message: "成功生成歌词文件",
          type: "success",
        });
        this.$emit("upLyricData", res.data.sourceUrl);
      });
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      this.$emit("upLyricData", file.data.sourceUrl);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit("upLyricData", "");
    },
  },
};
</script>

<style scoped lang="scss">
.upLyric {
  color: #fff;
  line-height: 40px;
  .svg-icon {
    font-size: 22px;
    vertical-align: middle;
  }
  .upload-demo {
    float: left;
    width: 140px;
  }
}
</style>
<style lang="scss">
.upLyric {
  .el-upload:focus {
    border-color: #fff;
    color: #fff;
  }
  .el-upload-list__item-name {
    color: #fff;
  }
  .el-textarea {
    width: 340px;
  }
  .upload-demo {
    ul {
      width: 340px !important;
    }
  }
  textarea {
    min-height: 150px !important;
  }
  .area {
    button {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 50px;
      height: 25px;
      background: #a99d53;
      border-radius: 10px;
      color: #fff;
      border: 1px solid #a99d53;
      font-size: 12px !important;
      padding: 0;
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upLrc.vue